/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Toast_Visibilityupdatefailed_Description3Inputs */

const en_settings_casmanagement_toast_visibilityupdatefailed_description3 = /** @type {(inputs: Settings_Casmanagement_Toast_Visibilityupdatefailed_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update visibility settings. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update visibility settings. Please try again." |
*
* @param {Settings_Casmanagement_Toast_Visibilityupdatefailed_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_toast_visibilityupdatefailed_description3 = /** @type {((inputs?: Settings_Casmanagement_Toast_Visibilityupdatefailed_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Toast_Visibilityupdatefailed_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_toast_visibilityupdatefailed_description3(inputs)
});
export { settings_casmanagement_toast_visibilityupdatefailed_description3 as "settings_casManagement_toast_visibilityUpdateFailed_description" }